<template>
    <transition name="page" mode="out-in">
        <div class="cover" v-if="loading">
            <div id="ballWrapper">
                <div id="ball" class="loading-ball"></div>
            </div>
        </div>
    </transition>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: 'spinner',

        computed: {
            ...mapGetters({settings: 'local/settings'}),

            loading() {
                return this.settings('loading')
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .cover
        position fixed
        height 100%
        width 100%
        top 0
        left 0
        background #fff
        z-index 1999


    #ballWrapper
        width 100px
        height 100px
        position fixed
        left 50%
        top 45%
        margin-left -50px
        z-index 100
        transform scale(1)
        cursor pointer

    #ballWrapper:active
        transform scale(0)
        cursor pointer

    .loading-ball
        width 90px
        height 90px
        position absolute
        border-radius 100%
        background: transparent url("../../../img/identity/ball-loading.svg") no-repeat center/contain
        top 0
        z-index 11
        animation wow 1s infinite
        cursor pointer
        background-size: 60%;
        img
            widt 100%
            object-fit contain

    /* Animation */

    @keyframes wow
        0%
            opacity 0.2
            animation-timing-function ease-in
        50%
            opacity 1
            animation-timing-function ease-out
        100%
            opacity 0.2
            animation-timing-function ease-in

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/spinner/Spinner.vue